import {CancelButton, ModalBase, Text} from '../../1elements'
import {DIV} from './styles'
import SaveButton from '../../1elements/Buttons/TextButtons/SaveButton'

const SaveConfirmationModal = ({open, setOpen, children, heading, icon, cancelHandler, saveHandler}) => {

    return (
        <ModalBase open={open} setOpen={setOpen} >
            <DIV>
                <div className={'modal-header'}>
                    <img src={icon} alt={heading} />
                    <Text type={'h8'}>{heading}</Text>
                </div>
                {children}
                <div className={'modal-footer'}>
                    <CancelButton onClick={cancelHandler} />
                    <SaveButton onClick={saveHandler} />
                </div>
            </DIV>
        </ModalBase>
    )
}

export default SaveConfirmationModal